import { get, find, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationUpcoming = get('reservation.upcoming');

export const getAll = createSelector(getReservationUpcoming, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getItemForBarcode = createSelector(
  (_, code) => ({ code }),
  getAllValues,
  find
);

export const getOrderedUpcoming = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getReservationUpcoming, get('order'));

export const getIsFetching = createSelector(
  getReservationUpcoming,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationUpcoming,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationUpcoming,
  get('fetchingError')
);

export const getIsSaving = createSelector(
  getReservationUpcoming,
  get('saving')
);

export const getIsSaved = createSelector(getReservationUpcoming, get('saved'));
